<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12">
                <h1 class="text-white pt-3 px-3">หน้าจัดการบริการเสริม</h1>
                <p
                    class="text-white pb-3 px-3"
                >ผู้ใช้งานสามารถเพิ่ม แก้ไข ลบหมวดหมู่บริการ และบริการเสริมในร้านค้าได้</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-12">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-12 col-xl-6 col-md-6 col-lg-5">
                                    <h3 class="text-muted">
                                        {{isServiceDetail() ? 'ตารางแสดงข้อมูลบริการเสริม' : 'ตารางแสดงข้อมูลหมวดหมู่' }}
                                        <small class="px-2"><a  href="https://docs.google.com/presentation/d/1cMq3nXeuROsVIISGOMUcC0t1NL69F0UKdUV_EHAma8A/edit?usp=sharing" v-if="$THEME.name == 'shippop'" target="_blank"> คู่มือการใช้งานบริการเสริม</a></small>
                                    </h3>
                                </div>
                                <div class="col-12 col-xl-4 col-md-6 col-lg-4 pb-2">
                                    <b-input-group>
                                        <b-form-input v-model="search.name" :placeholder="isServiceDetail() ? 'ค้นหาชื่อบริการเสริม' : 'ค้นหาชื่อหมวดหมู่'"></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="info" @click="isServiceDetail() ? getApiServiceDetails() : getApiCategoryService()">
                                                <i class="fa fa-search"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                                <div class="col-12 col-xl-2 col-md-12 col-lg-3 text-right">
                                    <b-button variant="primary" :class="isServiceDetail() ? 'px-2' : ''" @click="openModalAddCategoryService()">
                                       <i class="fas fa-plus"></i>
                                       {{isServiceDetail() ? 'เพิ่มบริการเสริม' : 'เพิ่มหมวดหมู่' }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <TableService
                            v-if="isServiceDetail()"
                            :search="search"
                            :service="service"
                            :addService="addService"
                            @getApiServiceDetails="getApiServiceDetails()"
                        />
                        <TableCategory
                            v-else
                            :search="search"
                            :category="category"
                            :addCategory="addCategory"
                            @getApiCategoryService="getApiCategoryService()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <ModalAddCategory
            :addCategory="addCategory"
            @getApiCategoryService="getApiCategoryService()"
        />
        <ModalAddService
            :addService="addService"
            :category="category"
            @getApiServiceDetails="getApiServiceDetails()"
        />
    </div>
</template>

<script>
import TableCategory from '@/components/custom/service/TableCategory'
import TableService from '@/components/custom/service/TableService'
import ModalAddService from '@/components/custom/service/ModalAddService'
import ModalAddCategory from '@/components/custom/service/ModalAddCategory'
import { getListCategoryService , getListCategoryDetails } from "@/axios/service.js";
import { showErrorModal } from "@/components/modalNotification.js";
import {additionalServiceCategoryList, additionalServiceList} from "@/api/additionalServices";

export default {
    components:{
        TableCategory,
        TableService,
        ModalAddService,
        ModalAddCategory,
    },
    data(){
        return{
            busy: false,
            category: [],
            service: [],
            search: {
              pageIndex: 1,
              pageSize: 25,
              totalItem: 0,
              name: ""
            },
            addCategory: {
                show: false,
                name: "",
                image: {
                    file: null,
                    preview: null,
                },
                type: "service",
                categoryId: null,
                isLoad: false,
                isLoadTable: false
            },
            addService: {
                show: false,
                name: "",
                categoryId: null,
                categoryName:null,
                categoryIdDefault: null,
                category:{},
                image: {
                    file: null,
                    preview: null,
                },
                rate: null,
                fee: null,
                serviceId: null,
                isLoad: false,
                isLoadTable: false
            }
        }
    },
    mounted(){
        this.getApiDefault()
    },
    methods:{
        getApiCategoryService(){
            this.addCategory.isLoadTable = true
            additionalServiceCategoryList(this.search, this.addCategory).then( res => {
              console.log(res)
                this.category = res.data.records
                this.search.page = res.data.pages
                this.search.totalItem = res.total
                this.clearLoading()
            }).catch( error => {
                showErrorModal(error)
                this.clearLoading()
            });
        },
        getApiServiceDetails(){
            this.addService.categoryId = this.$route.params.categoryId
            this.addService.isLoadTable = true;
            let params = {
              keyword: this.search.name || '',
              pageIndex: this.search.pageIndex,
              pageSize: this.search.pageSize,
              categoryId:this.addService.categoryId
              // total: this.search.total,
              // ...this.pagination,
            }
            additionalServiceList(params).then( res => {
                this.service = res.data.records
                this.search.page = res.data.pages
                this.search.totalItem = res.total
                this.clearLoading()
            }).catch( error => {
                showErrorModal(error)
                this.clearLoading()
            });
        },
        getApiDefault(){
            this.busy = true
            this.search.name = '';
            if( this.isServiceDetail() ){
                this.getApiServiceDetails()
            }else{
                this.getApiCategoryService()
            }
        },
        clearLoading(){
            this.busy = false
            this.addCategory.isLoadTable = false
            this.addService.isLoadTable = false
        },
        openModalAddCategoryService(){
            this.isServiceDetail() ? this.addService.show = true : this.addCategory.show = true
        },
        isServiceDetail() {
            return !!this.$route.params.categoryId;
        },
    },
    watch:{
        $route( to ) {
            if( to.name == 'categoryservice' ){
                this.addCategory.categoryId = null;
            }
            this.getApiDefault();
        }
    }
}
</script>
